import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { NivelacionesService } from '../_services/nivelaciones.service';
import { DynamicBarService } from '../../../_components/dynamic-bar/dynamic-bar.service';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_FORMATS } from '../../../_models/moment-formats';

@Component({
  selector: 'nivelaciones-reporte-rutas',
  standalone: false,
  templateUrl: 'nivelaciones-reporte.component.html',
  styleUrls: ['nivelaciones-reporte.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class NivelacionesReporteComponent implements OnInit, AfterViewInit {

  mockData = [
    { alumno: { nombresApellidos: 'Leigh Baker', codigo: 2345, curso: 'Kinder A' } },
    { alumno: { nombresApellidos: 'Irma Pope', codigo: 2346, curso: '1 A' } },
    { alumno: { nombresApellidos: 'Shaun Clark', codigo: 2347, curso: '2 B' } },
    { alumno: { nombresApellidos: 'Denise Fletcher', codigo: 2348, curso: '3 A' } },
    { alumno: { nombresApellidos: 'Antonia Rodríguez', codigo: 2349, curso: '4 A' } },
    { alumno: { nombresApellidos: 'Sherman Kim', codigo: 2350, curso: '5 A' } },
    { alumno: { nombresApellidos: 'Peter Lawrence', codigo: 2351, curso: '6 A' } },
    { alumno: { nombresApellidos: 'Angelica Bernett', codigo: 2352, curso: '7 A' } },
    { alumno: { nombresApellidos: 'Curtis Summers', codigo: 2353, curso: '8 A' } },
    { alumno: { nombresApellidos: 'Roger Mason', codigo: 2354, curso: '9 A' } },
    { alumno: { nombresApellidos: 'Frank Henderson', codigo: 2355, curso: '10 A' } },
    { alumno: { nombresApellidos: 'Dana Garza', codigo: 2356, curso: '11 B' } },
  ];

  dataSource: MatTableDataSource<any>;
  displayedColumns = ['Curso', 'Codigo', 'Alumno', 'Materias', 'Hora', 'Lugar'];

  fechaReporte: moment.Moment;
  fechaHoy: moment.Moment;
  fechaPicker: moment.Moment;
  botonInactivo = true;

  cargandoData = false;

  constructor(private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    private nivelacionesService: NivelacionesService,
    private dynamicBarService: DynamicBarService) {
  }

  ngOnInit() {
    this.fechaReporte = moment(this.route.snapshot.paramMap.get('fecha')
      ? this.route.snapshot.paramMap.get('fecha') : new Date(), 'YYYY-MM-DD');
    this.fechaHoy = moment(new Date());

    if (this.fechaReporte.isValid()) {
      this.cargandoData = true;
      this.fechaPicker = moment(new Date(this.fechaReporte.format('YYYY-MM-DD') + 'T05:00:00.000Z'));
      this.nivelacionesService.getReporte(this.fechaReporte.format('YYYY-MM-DD')).subscribe(res => {
        this.cargandoData = false;
        this.dataSource = new MatTableDataSource<any>(res);
      });
    }

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngAfterViewInit() {
    this.dynamicBarService.setBarra('nivelaciones-reporte-barra');
  }

  navegarAFecha() {
    this.router.navigate(['nivelaciones', 'reportes', 'rutas', 'fecha', this.fechaPicker.format('YYYY-MM-DD')]);
  }

  activarBoton() {
    this.botonInactivo = false;
  }

  imprimir() {
    window.print();
  }

  filtroTexto(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
}
